<template>
  <div class="page_all">
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">設定</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
        <tr>
          <th class="th_type">設定項目の選択</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="td_type">
            <router-link to="/passwordSetting">パスワードの変更</router-link>
          </td>
        </tr>
        <tr>
          <td class="td_type">
            <router-link to="/primaryLanguage">プライマリー言語</router-link>
          </td>
        </tr>
        <tr>
          <td class="td_type">
            <router-link to="/contact">お問い合わせ</router-link>
          </td>
        </tr>
        <tr v-if="this.$store.getters.getStateCompanyFlg == 1">
          <td class="td_type">
            <router-link to="/passwordSettingCompany">認証コードの変更</router-link>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            // メッセージ
            message: ""
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>


<style scoped>
  table th.th_type, table td.td_type {
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
  }
</style>